<template>
  <div class="central-newsroom-bound-field-wrapper">
    <v-layout
      row
      wrap
    >
      <v-flex
        xs10
        class="nx-channel-field-body"
      >
        <component
          :is="preparedFieldConfig.component"
          :key="key"
          :label="preparedFieldConfig.label"
          :name="preparedFieldConfig.name"
          :value="value"
          :validation="preparedFieldConfig.validation"
          :disabled="disabled || preparedFieldConfig.params.disabled"
          v-bind="preparedFieldConfig.params"
          @input="unbindField"
          @bcube-assistant="processAssistantEvent"
        />
      </v-flex>
      <v-flex xs2>
        <v-btn
          v-show="!isUnbound"
          large
          flat
          icon
          color="primary"
          :loading="loading"
        >
          <v-icon medium>
            fa-link
          </v-icon>
        </v-btn>
        <v-btn
          v-show="isUnbound"
          large
          flat
          icon
          color="secondary"
          :loading="loading"
          @click="bindField"
        >
          <v-icon medium>
            fa-unlink
          </v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Loadable from '@/mixins/loadable';
import PrepareFieldsConfig from '@/modules/form/mixins/prepare-fields-config';
import uniq from 'lodash/uniq';
import Storable from '@/mixins/storable';

export default {
  name: 'NxCentralNewsroomBoundField',
  inject: {
    $getParentEditor: {
      default: null,
    },
  },
  mixins: [Loadable, PrepareFieldsConfig, Storable],
  props: {
    disabled: Boolean,
    fieldConfig: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dirty: false,
    };
  },
  computed: {
    storePath() {
      if (this.$getParentEditor) {
        return this.$getParentEditor().storePath;
      }
      return ['content', 'editor'];
    },
    unboundFields() {
      return this.getters.unboundFields || [];
    },
    bindFields() {
      return this.getters.bindFields || [];
    },
    draft() {
      return this.getters.draft || {};
    },
    field() {
      return this.fieldConfig.field;
    },
    key() {
      return `bound-field.${this.field}`;
    },
    value() {
      return this.draft[this.field];
    },
    preparedFieldConfig() {
      return this.prepareFieldConfig(this.fieldConfig, this.key);
    },
    isUnbound() {
      if (this.dirty) {
        return true;
      }
      return this.unboundFields.includes(this.field) && !this.bindFields.includes(this.field);
    },
    parentForm() {
      return this.$parent;
    },
  },
  methods: {
    bindField() {
      const bindFields = uniq([...this.bindFields, this.field]);
      this.dispatch('UPDATE_FIELD', { bindFields });
      this.dirty = false;
    },
    unbindField() {
      const bindFields = [...this.bindFields].filter(f => f !== this.field);
      this.dispatch('UPDATE_FIELD', { bindFields });
      this.dirty = true;
    },
    updateField(field, value) {
      console.log('Update bound field: ', field, value);
      this.$parentForm.updateField(field, value);
    },
    processAssistantEvent(event) {
      this.unbindField();
      this.$emit('bcube-assistant', event);
    },
  },
};
</script>
